export default __webpack_public_path__ + "static/media/custom-marker.7eae0cd5.svg";